import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { SharedService } from '../../home/shared.service';
import { AlertService } from '../../util/alert/alert.service';
import { RemediationTagService } from './remediationtag.service';
import { UserService } from '../../user/user.service';
import { NoWhitespaceDirective } from "../../util/validator/nowhitespace.directive"
import { SanitizationService } from '../../sanitizer.service';
@Component({
	selector: 'app-addremediationtag',
	templateUrl: './addremediationtag.component.html'
})

export class AddRemediationTagComponent implements OnInit {
	addRemediationTag: FormGroup;
	constructor(private router: Router,
		private sharedService: SharedService,
		private alertServices: AlertService,
		private remediationTagService: RemediationTagService,
		private userService: UserService,
		private sanitizer: SanitizationService
	) {
		if (!userService.isValidLoggedIn()) {
			userService.redirectToLoginScreen();
		}

	}

	ngOnInit() {
		this.addRemediationTag = new FormGroup({
			remediationTag: new FormControl(null, Validators.required)
		});
	}

	cancel() {
		this.sharedService.change('RemediationTag');
	}

	saveAndNew() {

		this.remediationTagService.addRemediationTag(this.sanitizer.sanitize(this.addRemediationTag.value.remediationTag))
			.subscribe(
			data => {
				this.alertServices.clear();
				this.alertServices.success("Successfully added the remediation tag.");
				// this.addRemediationTag.reset();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	save() {

		this.remediationTagService.addRemediationTag(this.sanitizer.sanitize(this.addRemediationTag.value.remediationTag))
			.subscribe(
			data => {
				this.alertServices.clear();
				this.cancel();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

}
